import { SidebarMode } from '../models/enums/sidebar-mode.enum';

export class SetSideNavigationMode {
  static readonly type = '[Side navigation] Set side navigation';

  constructor(public payload: SidebarMode) {
  }
}
